import React, { useMemo } from 'react';
import * as ds from './dataService';
import { useParams } from 'react-router-dom';
import { StyledTable } from 'modules/components/layer24';
import { DocumentTableRow } from 'modules/components/layer23';


export type DocumentTableProps = {};

/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
export const FC = (props: DocumentTableProps) => {
  const params = useParams();
  const { data } = ds.useQuery(params.projectId ?? '');

  const headers = [
    'Name',
    'Size',
    'Created On',
    'Updated On',
    'Uploaded By'
  ];

  const rows = useMemo(
    () => {
      return data.map((node, i) => (
        <DocumentTableRow.FC
          key={i}
          {...node}
        />
      ));
    },
    [data]
  );

  return (
    <StyledTable.FC
      headers={headers}
      rows={rows}
    />
  );
};
